module.exports = __webpack_public_path__ + "img/ins_icons_hr.bfa1b654.svg";